function OptionsProvider() {
    'ngInject';

    function isObjectProperty(prop) {
        return typeof prop === 'object' && !Array.isArray(prop) && prop !== null;
    }

    function setOption(options, option, value) {

        guardNonExistingProperty(options, option);

        if (value === undefined) return Object.assign({}, options);

        if (!isObjectProperty(options[option])) {
            guardProps(options, option, value);

            const cleanedOptions = resetArrays(options, {[option]: value});
            return Object.assign({}, cleanedOptions, {[option]: value});
        }

        guardNonObjectValue(options, value);

        let guardedVal = Object.assign({}, options[option]);
        for (const [key] of Object.entries(value)) guardedVal = setOption(guardedVal, key, value[key]);

        const cleanedOptions = resetArrays(options, {[option]: value});
        return Object.assign({}, cleanedOptions, {[option]: guardedVal});
    }

    function guardNonExistingProperty(options, option) {
        if (!options.hasOwnProperty(option)) throw new Error('no option named:' + option);
    }

    function guardProps(options, option, value) {
        if (typeof  options[option] !== typeof value || Array.isArray(options[option]) !== Array.isArray(value)) {
            throw new Error(`option "${option}" required type is "${ Array.isArray(options[option]) ? 'array' : typeof options[option]}"`);
        }
    }

    function guardNonObjectValue(option, value) {
        if (!isObjectProperty(value)) throw new Error(`option "${option}" must be an object`);
    }

    function resetArrays(options, overrideOptions) {

        const cleanedOptions = Object.assign({}, options);

        for (const [key] of Object.entries(overrideOptions)) {
            if (Array.isArray(overrideOptions[key])) cleanedOptions[key] = [];
            else if (isObjectProperty(overrideOptions[key])) cleanedOptions[key] = resetArrays(cleanedOptions[key], overrideOptions[key]);
        }

        return cleanedOptions;
    }


    this.setOption = setOption;

    this.$get = () => {
        return {
            setOption
        };
    };

}

export default OptionsProvider;

/**
 * @description
 * Allows deep merge for non primitive and non array properties.
 */
angular
    .module('BB.utilities')
    .provider('bbOptions', OptionsProvider);



// WEBPACK FOOTER //
// node_modules/bookingbug-angular/src/core/-utilities/options/options.provider.js